(() => {
  const quoteUrl = '/pages/contact';

  const redirectToQuote = (event) => {
    event.preventDefault();
    window.location.assign(quoteUrl);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form instanceof HTMLFormElement && form.matches('form[action*="/cart/add"]')) redirectToQuote(event);
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element
      ? event.target.closest('#cart-checkout, #cart-sidebar-checkout, [data-btn-addToCart], [data-combo-addToCart], [data-express-addToCart], [data-bundle-addToCart]')
      : null;
    if (target) redirectToQuote(event);
  }, true);
})();
